import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "./store";

export interface ClubCapabilitiesState {
  uniqueKeys: string[] | null;
}

const initialState: ClubCapabilitiesState = {
  uniqueKeys: null,
};

const clubCapabilitiesSlice = createSlice({
  name: "clubCapabilities",
  initialState,
  reducers: {
    setClubCapabilities: (
      state,
      action: PayloadAction<{ capabilities?: string[] }>,
    ) => {
      state.uniqueKeys = action.payload.capabilities ?? null;
    },
    clearClubCapabilities: (state) => {
      state.uniqueKeys = null;
    },
  },
});

export const { setClubCapabilities, clearClubCapabilities } =
  clubCapabilitiesSlice.actions;
export default clubCapabilitiesSlice.reducer;

export const selectClubCapabilities = (state: RootState) =>
  state.clubCapabilities.uniqueKeys;
